function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("link", {
  type: "text/css",
  rel: "stylesheet",
  id: "dark-mode-custom-link"
});

var _ref3 = /*#__PURE__*/React.createElement("link", {
  type: "text/css",
  rel: "stylesheet",
  id: "dark-mode-general-link"
});

var _ref4 = /*#__PURE__*/React.createElement("style", {
  lang: "en",
  type: "text/css",
  id: "dark-mode-custom-style"
});

var _ref5 = /*#__PURE__*/React.createElement("style", {
  lang: "en",
  type: "text/css",
  id: "dark-mode-native-style"
});

var SvgRanksInactive = function SvgRanksInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511.934 511.934",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.822 223.199c4.062.828 8.021-1.791 8.852-5.861 1.854-9.085 2.793-18.433 2.793-27.788 0-76.046-61.682-137.915-137.5-137.915s-137.5 61.869-137.5 137.915 61.682 137.915 137.5 137.915c51.678 0 98.521-28.632 122.248-74.722 1.9-3.692.458-8.23-3.223-10.136-3.68-1.907-8.205-.458-10.105 3.232-21.142 41.068-62.877 66.58-108.919 66.58-67.547 0-122.5-55.119-122.5-122.87s54.953-122.87 122.5-122.87 122.5 55.119 122.5 122.87c0 8.343-.837 16.677-2.489 24.771-.831 4.071 1.786 8.046 5.843 8.879z",
    fill: "#afafaf",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.413 161.572c-.884-2.729-3.238-4.715-6.069-5.122l-48.88-7.023-21.764-44.459c-2.486-5.525-10.98-5.524-13.465 0l-21.764 44.458-48.88 7.023c-6.014.665-8.627 8.772-4.161 12.843l35.429 34.5-8.446 48.798c-1.228 5.924 5.634 10.946 10.893 7.939l43.661-23.137 43.661 23.137c5.251 3.007 12.124-2.015 10.893-7.939l-8.446-48.798 35.429-34.5c2.053-1.997 2.793-4.992 1.909-7.72zm-50.629 34.195c-1.779 1.732-2.589 4.233-2.166 6.684l6.511 37.619-33.659-17.837c-2.192-1.161-4.815-1.161-7.007 0l-33.659 17.837 6.511-37.619c.424-2.451-.387-4.952-2.166-6.684l-27.313-26.597 37.683-5.415c2.454-.353 4.576-1.898 5.669-4.131l16.778-34.273 16.778 34.273c1.093 2.232 3.215 3.778 5.669 4.131l37.683 5.415z",
    fill: "#afafaf",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.437 447.153-73.305-127.352c32.098-33.988 51.815-79.852 51.815-130.252-.001-104.518-84.776-189.549-188.98-189.549-32.061 0-63.735 8.201-91.6 23.717-3.622 2.017-4.928 6.596-2.917 10.229 2.01 3.631 6.576 4.941 10.197 2.926 25.643-14.279 54.8-21.826 84.32-21.826 95.933 0 173.979 78.283 173.979 174.504 0 96.222-78.046 174.505-173.979 174.505s-173.979-78.283-173.979-174.506c0-51.62 22.607-100.309 62.026-133.581 3.169-2.675 3.576-7.421.909-10.599-2.667-3.179-7.398-3.589-10.567-.912-42.813 36.137-67.368 89.021-67.368 145.092 0 50.486 19.783 96.422 51.978 130.428l-20.761 36.067c-4.975 8.35 8.189 16.07 12.99 7.523l18.873-32.787c22.579 20.271 50.027 35.185 80.345 42.74l-64.719 112.434-16.555-52.261c-1.173-3.705-4.969-5.901-8.755-5.07l-53.401 11.75 26.71-46.403c2.071-3.598.842-8.199-2.745-10.276-3.588-2.077-8.174-.845-10.245 2.753l-35.208 61.166c-3.34 5.373 1.964 12.674 8.102 11.11l63.317-13.933 19.629 61.966c1.716 6.096 10.646 7.089 13.643 1.483l75.719-131.547c9.792 1.577 19.83 2.408 30.059 2.408 10.313 0 20.431-.846 30.3-2.448l45.477 79.007c1.389 2.414 3.91 3.762 6.502 3.762 1.272 0 2.562-.325 3.743-1.009 3.587-2.078 4.816-6.678 2.745-10.276l-42.982-74.673c30.305-7.593 57.734-22.54 80.288-42.839l62.909 109.29-53.401-11.75c-3.786-.833-7.581 1.365-8.755 5.07l-16.555 52.261-4.004-6.956c-2.071-3.598-6.658-4.83-10.245-2.753-3.587 2.078-4.816 6.678-2.745 10.276l12.501 21.719c2.998 5.607 11.927 4.612 13.643-1.483l19.629-61.966 63.317 13.933c6.144 1.558 11.444-5.738 8.106-11.112z",
    fill: "#afafaf",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRanksInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ranks-inactive.1cae3456.svg";
export { ForwardRef as ReactComponent };